import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import LanguageMenu from '@/views/layout/components/pt/language-menu.vue';
import { mapGetters, mapState } from 'vuex';
import PtLogo from '@/views/layout/components/pt/logo.vue';
import SubscribeTips from './components/subscribe-tips';
import TaskCenter from '@pt/components/task-center/index.vue';
import WarrantMessage from './components/warrant-message/index.vue';
import { checkPlanCloseExpire } from '@pt/store/user/helper';
import TrialApplyDialog from '@pt/components/trial-apply-dialog/index';
import EditShowTitle from '@pt/components/edit-show-title';
import { getSessionStorage, removeSessionStorage } from '@com/utils/storage';
import { checkEmail } from '@pt/api/user/index';
import { ExistsStatus } from '@pt/api/user/type';
import { PermissionKey } from '@com/enums/user';
import store from '@pt/store';
import { isEnterpriseUser } from '@pt/components/grant-dialog/utils';
import { isPersonalUser } from '@pt/components/grant-dialog/utils';
import { localLanguage } from '@/common/storage';
import sendGtag from '@pt/utils/send-gtag.js';
import { handleTrial } from './components/subscribe-tips/utils';

export default {
  components: {
    LanguageMenu: LanguageMenu,
    PtLogo: PtLogo,
    SubscribeTips: SubscribeTips,
    EditShowTitle: EditShowTitle,
    TaskCenter: TaskCenter,
    WarrantMessage: WarrantMessage,
    TrialApplyDialog: TrialApplyDialog
  },

  computed: _extends({}, mapGetters(['username']), {
    partnerInfo: function partnerInfo() {
      return store.state.user.partnerInfo;
    },
    categoryInfo: function categoryInfo() {
      if (isPersonalUser(this.partnerInfo.category)) {
        return '' + this.$t('playTurbo.account.individual');
      }
      return '' + this.$t('playTurbo.account.enterprise');
    },
    firstLetter: function firstLetter() {
      return this.username.substr(0, 1).toUpperCase();
    },
    showTaskCenter: function showTaskCenter() {
      return !['common-template.multi-custom', 'common-template.custom'].includes(this.$route.name);
    }
  }, mapState({
    isGMaker: function isGMaker(state) {
      return state.pt.isGMaker;
    },
    jobUpdate: function jobUpdate(state) {
      return state.pt.websocket.jobUpdate;
    }
  }), {
    downloadsAndPush: function downloadsAndPush() {
      var userInfo = this.$store.state.user.info;

      if (!userInfo) return 0;
      if (!userInfo.plans) return 0;

      return userInfo.plans.reduce(function (prev, curr) {
        return prev + curr.downloads_and_push[0] + curr.extra_downloads_and_push[0];
      }, 0);
    },


    trialDialogVisible: {
      get: function get() {
        return this.$store.state.pt.trial.trialApplyDialogVisible;
      },
      set: function set() {
        this.$store.dispatch('pt/trial/toggleDialogVisible');
      }
    },

    grantPlanKey: function grantPlanKey() {
      return PermissionKey.GrantPlan;
    }
  }),

  data: function data() {
    return {
      visible: false,
      trialSuccessDialogVisible: false,
      trialSuccessDialogData: {},
      accountType: 0,
      localLanguage: localLanguage
    };
  },


  watch: {
    jobUpdate: function jobUpdate(val) {
      if (val && this.$refs.taskCenter) {
        this.$refs.taskCenter.getTaskList();

        this.$store.dispatch('GetUserInfo');
      }
    },
    downloadsAndPush: function downloadsAndPush(val) {
      console.log('downloadsAndPush change', val);
      checkPlanCloseExpire(this.$store.state.user.info);
    }
  },

  mounted: function mounted() {
    this.$store.dispatch('GetUserPartnerInfo');

    var refererStorage = getSessionStorage('referer');
    // 从auth页面登陆过来的链接中是否有数据存储
    if (refererStorage && JSON.parse(refererStorage) !== '{}') {
      var _JSON$parse = JSON.parse(refererStorage),
          email = _JSON$parse.email;
      // 校验用户注册信息


      if (email) {
        this.getCheckEmail(email);
      }
    }
  },


  methods: {
    userCategory: function userCategory() {
      if (isEnterpriseUser(this.partnerInfo.category)) {
        this.accountType = 1;
      }
    },
    navigate: function navigate(path) {
      this.$router.push({
        path: path
      });
    },
    goPaymentPage: function goPaymentPage() {
      this.userCategory();

      sendGtag({
        name: 'purchase_start'
      });

      this.navigate('/account-management/nl/subscription');
    },
    handleSuccess: function handleSuccess(data) {
      this.trialSuccessDialogVisible = true;
      this.trialSuccessDialogData = data;
      this.$store.dispatch('GetUserInfo');
    },
    handleClose: function handleClose() {
      this.trialSuccessDialogVisible = false;
      this.$router.replace({
        path: this.$route.path,
        query: {}
      });
      this.$router.go(0);
    },
    showAvatar: function showAvatar() {
      this.$store.dispatch('GetUserInfo');
      this.$store.dispatch('assets/uploader/getAssetsUsage');
    },
    logout: function logout() {
      this.$store.dispatch('LogOut');
    },
    visibleChange: function visibleChange(val) {
      this.visible = val;
    },
    handleTaskCenterShow: function handleTaskCenterShow() {
      this.$store.commit('pt/websocket/updateJobUpdate', false);
      this.$store.dispatch('GetUserInfo');
    },
    getCheckEmail: function getCheckEmail(email) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, exists;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return checkEmail(email);

              case 3:
                res = _context.sent;
                exists = res.data.data.exists;

                // 账号未注册，弹出申请试用弹窗(完成注册+试用套餐)

                if (exists === ExistsStatus.NeedRegister) {
                  // this.$store.dispatch('pt/trial/toggleDialogVisible')
                  handleTrial();
                } else {
                  // 账号已注册,直接使用PT平台并删除存储数据
                  removeSessionStorage('referer');
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  }
};